<template>
  <section
    :class="classes"
    data-cy="ds-form-layout"
  >
    <div
      :class="DS_FORM_LAYOUT_CLASSES.Content"
      data-cy="ds-form-layout__content"
    >
      <slot />
    </div>

    <footer
      v-if="$slots.footer"
      :class="DS_FORM_LAYOUT_CLASSES.Footer"
      data-cy="ds-form-layout__footer"
    >
      <slot name="footer" />
    </footer>
  </section>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { DS_FORM_LAYOUT_CLASSES, DS_FORM_LAYOUT_SIZE_CLASS } from "../constants/classes";
import type { DSFormLayoutProps } from "../types/props";
import { DS_SIZE } from "@/src/design_system/shared/types/size";

const props = withDefaults(defineProps<DSFormLayoutProps>(), {
  size: DS_SIZE.Small,
});

const classes = computed(() => [DS_FORM_LAYOUT_CLASSES.Root, DS_FORM_LAYOUT_SIZE_CLASS[props.size]]);
</script>
